import { IconWrapper, WrapperProps } from '../icon.style';
import styled from 'styled-components';
import COLORS from '../../../style/universal.color';

const { liveYellow, ticketGreen } = COLORS;

// TODO: Remove this for a better alternative (preferably fixing the mlb-icons
// generation method)
// These are a bunch of specific style overrides for some new icons added
// to mlb-icons that are broken due to issues with the json-generator
const Audio2Wrapper = styled(IconWrapper)`
  use {
    g {
      stroke: ${({ fill }: WrapperProps) => fill};
      stroke-width: 2;
      path {
        fill: none;
      }
      rect {
        &:nth-child(4),
        &:nth-child(5) {
          stroke-width: 1;
          fill: ${({ fill }: WrapperProps) => fill};
        }
      }
    }
  }
`;

const SadBaseballWrapper = styled(IconWrapper)`
  use {
    g {
      path {
        &:first-of-type,
        &:nth-child(3),
        &:nth-child(5) {
          fill: none;
        }
      }
    }
  }
`;

const Gameday2Wrapper = styled(IconWrapper)`
  use {
    path {
      stroke: ${({ fill }: WrapperProps) => fill};
      stroke-width: 2;
    }
  }
`;

const PreviewWrapper = styled(IconWrapper)`
  use {
    path {
      stroke-width: 0.5;
    }
    rect {
      stroke-width: 2;
    }
  }
`;

const Tickets2Wrapper = styled(IconWrapper)`
  use {
    g {
      path {
        &:first-of-type {
          fill: transparent;
        }
        &:nth-child(3) {
          fill-opacity: 0.25;
          stroke: ${({ fill }: WrapperProps) => fill};
          stroke-width: 2;
        }
      }
    }
  }
`;

const WrapWrapper = styled(IconWrapper)`
  use {
    g {
      rect {
        stroke-width: 2;
      }
      path {
        stroke: ${({ fill }: WrapperProps) => fill};
        &:first-of-type {
          stroke: transparent;
        }
      }
    }
  }
`;

export const IconWrapperOverrides = {
  'audio-2': Audio2Wrapper,
  'gameday-2': Gameday2Wrapper,
  box: Gameday2Wrapper,
  preview: PreviewWrapper,
  'tickets-2': Tickets2Wrapper,
  wrap: WrapWrapper,
  'sad-baseball': SadBaseballWrapper,
};

export const IconColorOverrides = {
  'tv-live': liveYellow,
  'tickets-2': ticketGreen,
};
